import { useState } from "react";

const plans = [
  {
    id: "monthly",
    name: "Monthly",
    price: "1,99",
    period: "/month",
    periodLabel: "Monthly billing",
    popular: false,
    features: [
      "No ads — completely ad-free",
      "Unlimited scans",
      "All premium filters unlocked",
      "OCR text extraction",
      "Priority support",
    ],
  },
  {
    id: "quarterly",
    name: "Quarterly",
    price: "3,99",
    period: " / 3 months",
    periodLabel: "Billed every 3 months",
    popular: true,
    savings: "Save 33%",
    features: [
      "No ads — completely ad-free",
      "Unlimited scans",
      "All premium filters unlocked",
      "OCR text extraction",
      "Priority support",
      "Watermark tools",
    ],
  },
  {
    id: "yearly",
    name: "Yearly",
    price: "5,99",
    period: " / year",
    periodLabel: "Billed annually",
    popular: false,
    savings: "Save 75%",
    features: [
      "No ads — completely ad-free",
      "Unlimited scans",
      "All premium filters unlocked",
      "OCR text extraction",
      "Priority support",
      "Watermark tools",
      "Digital signature",
      "PDF merge & split",
    ],
  },
];

export default function PricingSection() {
  const [selected, setSelected] = useState<string>("quarterly");

  return (
    <section id="pricing" className="w-full bg-white py-20 md:py-28">
      <div className="w-full px-6 md:px-10 lg:px-14">
        <div className="text-center mb-14 md:mb-18">
          <span className="inline-block text-sm font-medium text-[#F57C00] border border-[#F57C00]/30 rounded-full px-4 py-1.5 mb-5">
            Go Premium
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900 tracking-tight">
            Unlock Premium
          </h2>
          <p className="mt-4 text-base text-gray-500 max-w-xl mx-auto">
            Remove ads and access all advanced features with one simple subscription
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-5xl mx-auto">
          {plans.map((plan) => (
            <div
              key={plan.id}
              onClick={() => setSelected(plan.id)}
              className={`relative rounded-2xl p-7 md:p-8 border-2 cursor-pointer transition-all duration-300 ${
                selected === plan.id
                  ? "border-[#4CAF50] bg-[#F1F8E9] shadow-lg scale-[1.02]"
                  : "border-gray-100 bg-white hover:border-gray-200 hover:shadow-md"
              }`}
            >
              {plan.popular && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2">
                  <span className="bg-[#4CAF50] text-white text-xs font-bold px-4 py-1 rounded-full uppercase tracking-wide">
                    Most Popular
                  </span>
                </div>
              )}
              {plan.savings && !plan.popular && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2">
                  <span className="bg-[#F57C00] text-white text-xs font-bold px-4 py-1 rounded-full uppercase tracking-wide">
                    {plan.savings}
                  </span>
                </div>
              )}

              <h3 className="text-lg font-bold text-gray-900 mb-1 text-center">
                {plan.name}
              </h3>
              <p className="text-sm text-gray-500 text-center mb-5">
                {plan.periodLabel}
              </p>

              <div className="text-center mb-6">
                <span className="text-4xl md:text-5xl font-extrabold text-gray-900">
                  {plan.price}
                </span>
                <span className="text-lg font-medium text-gray-500 ml-1">
                  €
                </span>
                <span className="text-sm text-gray-400 ml-1">{plan.period}</span>
              </div>

              <ul className="space-y-3 mb-8">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-[#4CAF50] text-base"></i>
                    </span>
                    <span className="text-sm text-gray-600">{feature}</span>
                  </li>
                ))}
              </ul>

              <button
                className={`w-full py-3 rounded-full text-sm font-bold transition-colors whitespace-nowrap ${
                  selected === plan.id
                    ? "bg-[#4CAF50] text-white hover:bg-[#43A047]"
                    : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                }`}
              >
                {selected === plan.id ? "Selected Plan" : "Choose Plan"}
              </button>
            </div>
          ))}
        </div>

        <p className="text-center text-sm text-gray-400 mt-10">
          Cancel anytime. All plans include a 7-day free trial.
        </p>
      </div>
    </section>
  );
}